import React from 'react';
import { connect } from 'react-redux';
import MenuItem from '../layout/MenuItem';
import { loadMainMenu, keepOpenedMenu } from '../../actions';
import classNames from "classnames";
import Icon from "../form/Icon";


class MainMenu extends React.Component {
	constructor(props) {
		super(props);
		props.loadMainMenu();
	}

  	render() {
  		return <ul className="sidebar-menu tree" data-widget="tree">
  			{this.props.header ? <li className="header">{this.props.header}</li>: ""}
            <li>
				<a
					href="#"
					onClick={(e) => {
						e.preventDefault();
						this.props.keepOpenedMenu(!this.props.config.keepOpened);
						this.forceUpdate();
					}}>
						<Icon
							lib="fa"
							name={classNames({"circle-o": !this.props.config.keepOpened, "circle": this.props.config.keepOpened})}
						/>
							<span>Nyitva marad</span>
				</a>
			</li>
  			{this.props.config.items.map((menuitem, i)=>
				<MenuItem key={i} position={i} {...menuitem} level={this.props.level} />
			)}
  		</ul>;
	}
}

export default connect((state) => {
	return {
		config: state.app.template.menu
	};
},{loadMainMenu, keepOpenedMenu})(MainMenu);